import React, { useCallback } from "react";
import ButtonBase from "@mui/material/ButtonBase";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import AssetItemImage from "../../capture/aseet-list/AssetItemImage";
import AssetItemSkeleton from "../../capture/aseet-list/AssetItemSkeleton";
import AssetItemDescription from "../../capture/aseet-list/AssetItemDescription";
import Checkbox from "@mui/material/Checkbox";

const styles = {
  button: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    border: 0,
    boxSizing: "border-box",
    borderBottom: "1px solid #DDDBDA",
    height: 80,
    textAlign: "left",
    width: "100%",
    overflow: "hidden",
    padding: "8px 8px",
    "&:hover": {
      backgroundColor: "#f4f6f8",
    },
  },
  arrow: {
    fontSize: 18,
    color: "action.active",
    ml: 1,
  },
};

export default function AssetListItem({ order, asset, style, setSelected, checked, onCheck }) {
  const handleSelect = useCallback(
    async e => {
      if (e.target.type === "checkbox") return;
      setSelected(asset);
    },
    [asset, setSelected]
  );

  if (!asset) {
    return (
      <div style={style} data-id="assets-list">
        <AssetItemSkeleton />
      </div>
    );
  }

  return (
    <div style={style} data-id="assets-list">
      <ButtonBase fullWidth variant="outlined" sx={styles.button} onClick={handleSelect}>
        <Checkbox
          checked={checked}
          onChange={() => onCheck && onCheck(asset)}
          disableRipple
          sx={{ mr: 1 }}
        />
        <AssetItemImage images={asset.images} />
        <AssetItemDescription
          displayItemId={false}
          order={order}
          asset={asset}
          descriptionLines={3}
        />
        <ArrowForwardIosIcon sx={styles.arrow} />
      </ButtonBase>
    </div>
  );
}
